import { RoutePathModel } from "../interface/common.interface";
export const UPLOAD_TAX_INCOME_ROUTE: RoutePathModel = {
  path: "upload-tax-income",
  url: "/upload-tax-income",
  name: "upload-tax-income",
  meta: {
    title_head: "lbl_upload_tax_income",
    need_auth: true,
    breadcrumb: [
      {
        name: "lbl_upload_tax_income",
        icon: "upload",
        href: "/upload-tax-income",
      },
    ],
  },
};
